// base component
import { InfoComponent } from './info.component';

// components

export const InfoModule = angular.module('topbroker.info', [])
  .component('info', InfoComponent)
  .name;
